import { render, staticRenderFns } from "./RimborsoBollette.vue?vue&type=template&id=4a083aa6&scoped=true"
import script from "./RimborsoBollette.vue?vue&type=script&lang=js"
export * from "./RimborsoBollette.vue?vue&type=script&lang=js"
import style0 from "./RimborsoBollette.vue?vue&type=style&index=0&id=4a083aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a083aa6",
  null
  
)

export default component.exports